var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBuyer = function SvgIconBuyer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -6)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#6A0",
    cx: 19,
    cy: 18,
    r: 11.143
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#480",
    d: "M12.571 22.629H25.43v4.714L19.116 29.4l-6.545-2.058z"
  }), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.5,
    fill: "#FFF",
    cx: 19,
    cy: 15.429,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.03 29.921c6.623 0 11.989-5.365 11.989-11.988 0-6.622-5.366-11.988-11.989-11.988-6.622 0-11.988 5.366-11.988 11.988 0 6.623 5.366 11.988 11.988 11.988zm7.667-4.926c-.329-2.242-2.238-3.968-4.573-3.968-.99 0-1.47.55-3.094.55-1.624 0-2.098-.55-3.093-.55-2.335 0-4.245 1.726-4.573 3.968a10.385 10.385 0 0 1-2.775-7.062c0-5.757 4.684-10.441 10.441-10.441 5.758 0 10.442 4.684 10.442 10.441 0 2.726-1.059 5.201-2.775 7.062zm-7.667-5.128a4.254 4.254 0 1 0 0-8.508 4.254 4.254 0 0 0 0 8.508zm0-1.547a2.709 2.709 0 0 1-2.707-2.707 2.709 2.709 0 0 1 2.707-2.707 2.709 2.709 0 0 1 2.707 2.707 2.709 2.709 0 0 1-2.707 2.707zm0 10.054c-2.315 0-4.452-.768-6.187-2.05v-.657a3.097 3.097 0 0 1 3.094-3.093c.536 0 1.329.55 3.093.55 1.77 0 2.553-.55 3.094-.55a3.097 3.097 0 0 1 3.094 3.093v.658a10.386 10.386 0 0 1-6.188 2.05z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
export default SvgIconBuyer;